import React from "react";
import {Box, Text, Progress, Flex} from "@chakra-ui/react";

interface UtilizationProgressBarProps {
  usedMinutes: number;
  totalMinutes: number;
}

const formatMinutes = (minutes: number) => {
  return minutes > 120 ? `${(minutes / 60).toFixed(1)}h` : `${minutes}m`;
};

const getColorScheme = (percentage: number) => {
  if (percentage <= 50) return "green";
  if (percentage <= 85) return "orange";
  return "red";
};

const UtilizationProgressBar: React.FC<UtilizationProgressBarProps> = (
  {
    usedMinutes,
    totalMinutes,
  }) => {
  const percentage = Math.min((usedMinutes / totalMinutes) * 100, 100);
  const colorScheme = getColorScheme(percentage);

  const label = `Used ${formatMinutes(usedMinutes)} / ${formatMinutes(totalMinutes)}`;

  return (
    <Box w="full">
      <Flex justify="center" mb={1}>
        <Text fontSize="sm">{label}</Text>
      </Flex>
      <Progress
        value={percentage}
        colorScheme={colorScheme}
        size="sm"
        bg="gray.700"
        rounded="full"
      />
    </Box>
  );
};

export default UtilizationProgressBar;